import React from 'react'
import moment from 'moment'
import normalizeURL from 'normalize-url'
import { keysIn, pick, propEq, find } from 'ramda'

import { A, Avatar, Div, IconButton, Input, Span, Tag, ToolTip } from '@driftt/tide-core'
import { NO_USER_COPY, MANAGED_BY_SF_COPY } from './constants'

const cellFormats = (index, value, key, account, users, isSelected, openEdit, openDelete, openSideBar, toggleSelected) => {
  const onToggle = checked => toggleSelected(checked, index)
  const pass = value => value

  const format = {
    select: () => (
      <Input type="checkbox" onChange={onToggle} checked={isSelected} />
    ),
    actions: () => {
      return account.sfAccountId ? 
        <ManagedBySF account={account} openDelete={openDelete} index={index} /> : 
        <AccountActions account={account} openEdit={openEdit} openDelete={openDelete} index={index} />
    },
    name: name => <CompanyCell name={name} account={account} openSideBar={openSideBar} /> ,
    updateDateTime: (date) => {
      return !date ? '--' : moment(date).format('MM/DD/YYYY');
    },
    domain: domain => (
      <A
        className="accounts-table-domain"
        href={normalizeURL(domain)} 
        target="_blank">
        {normalizeURL(domain, {normalizeHttps: true}).replace('http://', 'www.')}
      </A>
    ),
    ownerId: userId => { 
      const user = find(propEq('id', userId))(users)
      return user ? <UserCell user={user} /> : NO_USER_COPY
    },
    targeted: targeted => {
      return targeted ? <Tag text="ABM" wrapperClass="accounts-table-abm-tag"/> : <Div></Div>
    }
  }
  
  const formatter = format[key] || pass

  return formatter(value)
}

const ManagedBySF = ({ openDelete, account, index }) => (
  <Div className="accounts-row-actions">    
    <Span tooltip={MANAGED_BY_SF_COPY} flow="left" className="accounts-table-managed-by-sf"><IconButton icon="sync" size="medium" inline={true}  inlineStyle="subtle" /></Span>
    <Span onClick={() => openDelete(account, index)}><IconButton icon="trash" size="medium" inline={true}  inlineStyle="subtle" /></Span>
  </Div>
)

const AccountActions = ({ openEdit, openDelete, account, index }) => (
  <Div className="accounts-row-actions">    
    <ToolTip flow="up" component={'Edit account'}>
      <Span onClick={() => openEdit(account)}><IconButton icon="edit-1" size="medium" inline={true} inlineStyle="subtle" /></Span>
    </ToolTip>
    <ToolTip flow="up" component={'Delete account'}>
      <Span onClick={() => openDelete(account, index)}><IconButton icon="trash" size="medium" inline={true} inlineStyle="subtle" /></Span>
    </ToolTip>
  </Div>
)

const UserCell = ({ user }) => (
  <Span>{user.name || user.email}</Span>
)

const CompanyCell = ({ name, account, openSideBar }) => (
  <Div className="accounts-table-company-cell" onClick={() => openSideBar(account.accountId)}>
    <Avatar type="company" company={account.companyData} />
    <Span>{name}</Span>
  </Div>
)

export const formatAccountDataForTable = (accounts, users, selectedRows, openEdit, openDelete, openSideBar, toggleSelected) => {
  const format = (account, index) => {
    const isSelected = selectedRows.includes(index)
    const data = pick(['name', 'domain', 'ownerId', 'updateDateTime', 'targeted'], account)
    const toContent = key => ({
      customKey: account.id,
      content: cellFormats(
        index,
        data[key],
        key,
        account,
        users,
        isSelected,
        openEdit,
        openDelete,
        openSideBar,
        toggleSelected
      )
    })
    let columns = ['select', ...keysIn(data), 'actions']

    return { data: columns.map(toContent)}
  }

  return accounts.map(format)
}
